"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Address = function Address(_ref) {
  var city = _ref.city,
      postalCode = _ref.postalCode,
      street = _ref.street,
      number = _ref.number;

  if (!city && !postalCode && !street && !number) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MapPin, null), street, " ", number, /*#__PURE__*/_react["default"].createElement("br", null), postalCode, " ", city);
};

Address.propTypes = {
  city: _propTypes["default"].string,
  postalCode: _propTypes["default"].string,
  street: _propTypes["default"].string,
  number: _propTypes["default"].string
};
Address.defaultProps = {
  city: '',
  postalCode: '',
  street: '',
  number: ''
};
var _default = Address;
exports["default"] = _default;